'use strict';

function isInteger(n) {
  return n % 1 === 0;
}

module.exports = isInteger;